import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VueReCaptcha } from 'vue-recaptcha-v3'

createApp(App).use(VueReCaptcha, { siteKey: '6LckD1waAAAAALUtuJYSAR8c05SijZEo9MUIo5ml' }).use(store).use(router).mount('#app')
